/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ar_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. All calculations happen in your browser; nothing is uploaded.`)
};

const es_ar_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Todos los cálculos ocurren en tu navegador; nada se sube.`)
};

const de_ar_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Alle Berechnungen finden in deinem Browser statt; es wird nichts hochgeladen.`)
};

const nl_ar_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Alle berekeningen vinden plaats in je browser; niets wordt geüpload.`)
};

const fr_ar_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Tous les calculs se font dans votre navigateur ; rien n'est téléchargé.`)
};

const it_ar_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Tutti i calcoli avvengono nel tuo browser; nulla viene caricato.`)
};

const pt_br2_ar_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Todos os cálculos acontecem no seu navegador; nada é enviado.`)
};

const pt_ar_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Todos os cálculos ocorrem no seu navegador; nada é enviado.`)
};

const ja_ar_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。すべての計算はブラウザで行われます。何もアップロードされません。`)
};

const zh_ar_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。所有计算都在你的浏览器中完成,不会上传任何内容。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ar_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ar_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ar_faq3_a", locale)
	if (locale === "en") return en_ar_faq3_a(inputs)
	if (locale === "es") return es_ar_faq3_a(inputs)
	if (locale === "de") return de_ar_faq3_a(inputs)
	if (locale === "nl") return nl_ar_faq3_a(inputs)
	if (locale === "fr") return fr_ar_faq3_a(inputs)
	if (locale === "it") return it_ar_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_ar_faq3_a(inputs)
	if (locale === "pt") return pt_ar_faq3_a(inputs)
	if (locale === "ja") return ja_ar_faq3_a(inputs)
	return zh_ar_faq3_a(inputs)
};